import { Button, Modal } from '@mairistem/composants';
import {
	getErrorMessage,
	ModalSuperUserValidation,
} from '@mairistem/finances-utils';
import React from 'react';
import { toast } from 'react-toastify';
import DECISION from '../../constants/common/decision';
import type Projet from '../../interfaces/common/projet';
import { deleteProjet } from '../../services/projet';

interface AutorisationDeleteModalProps {
	autorisation: Projet;
	onClose: () => void;
	onDeleted: () => void;
}

const AutorisationDeleteModal = ({
	autorisation,
	onClose,
	onDeleted,
}: AutorisationDeleteModalProps) => {
	const [loading, setLoading] = React.useState(false);
	const [isValidated, setIsValidated] = React.useState(false);
	const typeLabel =
		autorisation.decision === DECISION.AP ? 'de programme' : "d'engagement";

	const handleConfirm = async () => {
		setLoading(true);
		try {
			await deleteProjet(autorisation.identifiant as number);
			toast.success(`L'autorisation ${typeLabel} a été supprimée`);
			onDeleted();
			onClose();
		} catch (e) {
			toast.error(
				getErrorMessage(e, "Erreur lors de la suppression de l'autorisation"),
			);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal closeOnDimmerClick={false} onClose={onClose} open size="medium">
			<Modal.Header content="Supprimer l'autorisation" />

			<Modal.Content>
				<p>
					Êtes-vous sûr de vouloir supprimer l'autorisation {typeLabel}{' '}
					<strong>{autorisation.libelle}</strong> ?
				</p>
				<p>Cette action est irréversible.</p>
				<ModalSuperUserValidation
					message={`La suppression d'une autorisation ${typeLabel} est définitive et entraînera la suppression de l'ensemble des données associées.`}
					onChange={setIsValidated}
				/>
			</Modal.Content>

			<Modal.Actions>
				<Button content="Annuler" disabled={loading} onClick={onClose} />
				<Button
					content="Supprimer"
					disabled={loading || !isValidated}
					loading={loading}
					negative
					onClick={handleConfirm}
				/>
			</Modal.Actions>
		</Modal>
	);
};

export default AutorisationDeleteModal;
